import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Views } from "react-big-calendar";

import { ANCalendar } from "@answersnow/pkg-theme";
import styles from "./styles";
import {
  createRecurrentEvents,
  createProposedEvents,
  getUpdatedGeneratedSchedule,
} from "./calendarUtils";
import { useMatching } from "../MatchingProvider";

const MonthDayWrapper = ({ date }) => {
  const weekDay = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(date);

  return (
    <Box>
      <Typography variant="body2" component="span" mr={2}>
        {weekDay}
      </Typography>
    </Box>
  );
};

const currentDate = new Date();

const MatchingCalendar = () => {
  const {
    generatedSchedules,
    getClinicianSchedule,
    nonWorkingHours,
    isEventsLoading,
    recurringEventData,
    selectedClient,
    selectedClinician,
    setGeneratedSchedules,
    singleEvents,
  } = useMatching();

  const calendarEvents = useMemo(() => {
    const clinicianSchedule = getClinicianSchedule(selectedClient);
    const proposedEvents = createProposedEvents(clinicianSchedule?.allEvents, singleEvents);
    const recurrentEvents = createRecurrentEvents(recurringEventData);

    return [...recurrentEvents, ...proposedEvents];
  }, [generatedSchedules, selectedClinician]);

  // Custom components for the ANCalendar component
  const components = { header: MonthDayWrapper };

  // Only the proposed events are draggable and resizable
  const draggableAccessor = (event) => event.is_proposed;

  const handleEventChange = (event) => {
    const originalEvent = calendarEvents.find((e) => e.id === event.id);

    const updatedGeneratedSchedules = getUpdatedGeneratedSchedule({
      originalEvent,
      newEvent: event,
      generatedSchedules,
    });

    setGeneratedSchedules(updatedGeneratedSchedules);
  };

  return (
    <Box direction="row" component="section" sx={styles}>
      <ANCalendar
        dragAndDrop
        dragToPast
        reinitialize={!isEventsLoading}
        draggableAccessor={draggableAccessor}
        view={Views.WEEK}
        views={[Views.WEEK]}
        date={currentDate}
        toolbar={false}
        components={components}
        nonWorkingHours={nonWorkingHours ?? []}
        events={calendarEvents}
        onView={() => {}}
        onNavigate={() => {}}
        onChangeEvent={handleEventChange}
        scrollToTime={new Date(0, 0, 0, 8)}
      />
    </Box>
  );
};

export default MatchingCalendar;
